/**
 * Generic popup handling for the theme.
 *
 * Usage pattern:
 * - Trigger element: add [data-ws-popup-open] (or legacy [data-open-popup])
 * - Optional: add data-ws-popup-target="#id-or-selector" to point to a <template>
 * - Fallback: within the closest [data-ws-popup-root] search for <template.ws-popup-template>
 * - Template must contain a single root element with class "ws-popup"
 * - Closing:
 *   - click on .ws-popup__close
 *   - click on any [data-ws-popup-close]
 *   - click on overlay background
 *   - press Escape
 */
(function () {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
        return;
    }

    function findTemplate(button) {
        if (!button) return null;

        // Prefer explicit selector
        var targetSelector = button.getAttribute('data-ws-popup-target');
        var root = button.closest('[data-ws-popup-root]') || document;
        var tpl = null;

        if (targetSelector) {
            try {
                tpl = root.querySelector(targetSelector) || document.querySelector(targetSelector);
            } catch (e) {
                // Invalid selector; ignore
                tpl = null;
            }
        }

        if (!tpl) {
            // Walk up DOM from the trigger towards the root and look for the
            // nearest container that *contains* a popup template. This ensures
            // each item/slide uses its own template instead of the first one
            // within the entire block.
            var container = button;
            while (container && container !== root && container !== document.body) {
                if (container.querySelector) {
                    tpl = container.querySelector('template.ws-popup-template');
                    if (tpl && tpl.content) {
                        break;
                    }
                }
                container = container.parentElement;
            }
        }

        if (!tpl && root && root.querySelector) {
            // Fallback: first template inside the popup root
            tpl = root.querySelector('template.ws-popup-template');
        }

        if (!tpl || !tpl.content) return null;
        return tpl;
    }

    function openFromTemplate(button) {
        var tpl = findTemplate(button);
        if (!tpl) return;

        var rootEl = tpl.content.firstElementChild;
        if (!rootEl) return;

        // Clone popup content
        var overlay = document.createElement('div');
        overlay.className = 'ws-popup-overlay';

        var popup = rootEl.cloneNode(true);
        if (!popup.classList.contains('ws-popup')) {
            popup.classList.add('ws-popup');
        }

        // Basic ARIA defaults
        if (!popup.hasAttribute('role')) {
            popup.setAttribute('role', 'dialog');
        }
        if (!popup.hasAttribute('aria-modal')) {
            popup.setAttribute('aria-modal', 'true');
        }

        overlay.appendChild(popup);
        document.body.appendChild(overlay);

        // Trigger fade-in on next frame
        requestAnimationFrame(function () {
            overlay.classList.add('is-active');
        });

        function close() {
            if (!overlay || !overlay.parentNode) {
                document.removeEventListener('keydown', onKey);
                return;
            }

            // Start fade-out
            overlay.classList.remove('is-active');
            overlay.classList.add('is-closing');

            var removed = false;
            function cleanup() {
                if (removed) return;
                removed = true;
                if (overlay && overlay.parentNode) {
                    overlay.parentNode.removeChild(overlay);
                }
                document.removeEventListener('keydown', onKey);
            }

            // Prefer transitionend, but also set a max timeout
            overlay.addEventListener('transitionend', cleanup, { once: true });
            setTimeout(cleanup, 350);
        }

        function onKey(e) {
            if (e.key === 'Escape' || e.key === 'Esc') {
                close();
            }
        }

        document.addEventListener('keydown', onKey);

        // Close when clicking outside popup
        overlay.addEventListener('click', function (e) {
            if (e.target === overlay) {
                close();
            }
        });

        // Close buttons
        var closeButtons = popup.querySelectorAll('[data-ws-popup-close], .ws-popup__close');
        if (closeButtons && closeButtons.length) {
            closeButtons.forEach(function (btn) {
                btn.addEventListener('click', function (e) {
                    e.preventDefault();
                    close();
                });
            });
        }
    }

    function handleClick(e) {
        var target = e.target;
        if (!target) return;

        var btn = target.closest('[data-ws-popup-open], [data-open-popup]');
        if (!btn) return;

        // Prevent default navigation / submit
        if (typeof e.preventDefault === 'function') {
            e.preventDefault();
        }

        openFromTemplate(btn);
    }

    document.addEventListener('click', handleClick);

    try {
        window.wsPopup = window.wsPopup || {};
        window.wsPopup.openFromTemplate = openFromTemplate;
    } catch (e) {
        // no-op
    }
})();


